import { Head } from '@inertiajs/react'
import baselineLogo from '@/assets/baseline-no-padding.svg'
import { SiteLayout } from '@/components/site-layout'
import { awardGroups } from '@/data/award-categories'

import img1 from '@/assets/hang-muc/1-nam-vdv.jpg'
import img2 from '@/assets/hang-muc/2-nu-vdv.jpg'
import img3 from '@/assets/hang-muc/3-doi-nam.jpg'
import img4 from '@/assets/hang-muc/4-doi-nu.jpg'
import img5 from '@/assets/hang-muc/5-doi-nam-nu.jpg'
import img6 from '@/assets/hang-muc/6-doi-nam-tre.jpg'
import img7 from '@/assets/hang-muc/7-nu-tre.jpg'
import img8 from '@/assets/hang-muc/8-nam-40+.jpg'
import img9 from '@/assets/hang-muc/9-nu-40+.jpg'
import img10 from '@/assets/hang-muc/10-cau-lac-bo.png'
import img11 from '@/assets/hang-muc/11-giai-dau.jpg'
import img12 from '@/assets/hang-muc/12-cum-san.jpg'
import img13 from '@/assets/hang-muc/13-cong-dong.jpg'
import img14 from '@/assets/hang-muc/14-clb-hoat-dong.jpg'
import img15 from '@/assets/hang-muc/15-nha-sang-tao-noi-dung.jpg'
import img16 from '@/assets/hang-muc/16-nam-nghe-si.jpg'
import img17 from '@/assets/hang-muc/17-nu-nghe-si.jpg'
import img18 from '@/assets/hang-muc/18-thuong-hieu.jpg'

const categoryImages: Record<string, string> = {
  'mens-player-year': img1,
  'womens-player-year': img2,
  'mens-doubles-year': img3,
  'womens-doubles-year': img4,
  'mixed-doubles-year': img5,
  'mens-u18-prospect': img6,
  'womens-u18-prospect': img7,
  'mens-40plus': img8,
  'womens-40plus': img9,
  'pickleball-club-year': img10,
  'pickleball-tournament-year': img11,
  'pickleball-venue-year': img12,
  'media-community-year': img13,
  'social-play-club-year': img14,
  'content-creator-year': img15,
  'male-celebrity-advocate': img16,
  'female-celebrity-advocate': img17,
  'brand-development-partner': img18,
}

type Props = {
  submission_window: string
}

export default function CategoriesIndex(_props: Props) {
  return (
    <SiteLayout>
      <Head title="Hạng mục | Vietnam Pickleball Awards 2025" />

      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
        <div className="mb-8 rounded-2xl border border-[#042133]/10 bg-white/85 p-6 shadow-[0_24px_70px_-50px_rgba(4,33,51,0.4)] sm:p-10">
          <p className="text-[#5b7788] text-[10px] uppercase tracking-[0.25em]">
            Danh mục giải thưởng
          </p>
          <h2 className="mt-3 font-semibold text-2xl sm:text-3xl">
            Các hạng mục Vietnam Pickleball Awards
          </h2>
          <p className="mt-3 text-[#5b7788] text-sm sm:text-base">
            Chọn hạng mục phù hợp để gửi đề cử. Các giải thưởng được chia theo nhóm chủ đề nhằm tôn
            vinh cộng đồng, thương hiệu và vận động viên xuất sắc. Tính năng bình chọn trên
            <a
              href="https://baseline.live"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-baseline align-baseline"
            >
              <img
                src={baselineLogo}
                alt="Baseline"
                className="mx-1 inline-block h-[1.2em] w-auto align-baseline"
              />
            </a>
            sẽ sớm ra mắt — hãy tải app ngay để sẵn sàng tham gia voting trong thời gian tới.
          </p>
        </div>

        <div className="grid gap-6 sm:gap-8">
          {awardGroups.map((section, index) => (
            <section
              key={section.id}
              className="rounded-2xl border border-[#042133]/10 bg-white/80 p-6 shadow-[0_20px_60px_-45px_rgba(4,33,51,0.45)] sm:p-8"
            >
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <p className="text-[#5b7788] text-[10px] uppercase tracking-[0.25em]">
                    Nhóm {index + 1}
                  </p>
                  <h3 className="mt-2 font-semibold text-xl sm:text-2xl">{section.titleVi}</h3>
                </div>
                <span className="rounded-full border border-[#042133]/15 bg-white px-4 py-1 text-[#5b7788] text-[10px] uppercase tracking-[0.2em]">
                  {section.items.length} hạng mục
                </span>
              </div>

              <div className="mt-4 grid gap-4 sm:mt-6 sm:grid-cols-2">
                {section.items.map((item) => (
                  <article
                    key={item.id}
                    className="overflow-hidden rounded-2xl border border-[#042133]/10 bg-white/90 text-[#042133] shadow-sm"
                  >
                    {categoryImages[item.id] && (
                      <div className="aspect-[1.8/1] w-full">
                        <img
                          src={categoryImages[item.id]}
                          alt={item.nameVi}
                          className="h-full w-full object-cover"
                        />
                      </div>
                    )}
                    <div className="p-3 sm:p-4">
                      <p className="font-semibold text-sm sm:text-base">{item.nameVi}</p>
                      <p className="mt-1 text-[#5b7788] text-xs sm:text-sm">{item.descriptionVi}</p>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </SiteLayout>
  )
}
